import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base";
import { MasterPlan } from "../../domain/models/master-plan";
import { MasterPlanByLocationProductIdRequest } from "../../domain/requests";
import { PlanningPortalRepository } from "../../repositories";

@Injectable({providedIn: 'root'})
export class GetMasterPlansByLocationIdAndProductIdUsecase implements UseCase<MasterPlanByLocationProductIdRequest, MasterPlan[]> {

  constructor(private planningPortalRepository: PlanningPortalRepository) {
  }

  execute(params: MasterPlanByLocationProductIdRequest): Observable<MasterPlan[]> {
    return this.planningPortalRepository.getMasterPlanByLocationIdAndProductId(params);
  }

}
